import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { api } from '../lib/api';

export default function DownloadPage() {
  const [apkHref, setApkHref] = useState('/app.apk');
  const altHref = '/download/app.apk';
  const navigate = useNavigate();
  useEffect(() => { api.get('/download/apk').then(({ data }) => { if (data && typeof data.url === 'string' && data.url.length) setApkHref(data.url); }).catch(() => { }); }, []);
  return (
    <div
      className="max-w-md mx-auto min-h-[100vh] cursor-pointer"
      onClick={() => window.open(apkHref, '_blank')}
    >
      <img src="/images/download.jpg" alt="下载" />

    </div>
  );
}